import React from 'react';
import { PurchaseButton } from '../PurchaseButton';
import { PriceTag } from '../PriceTag';
export function FinalCta() {
  return <section className="bg-graphite text-ivory" data-id="element-86" data-mp="22dcni7qh4h3b">
      <div className="mx-auto max-w-site px-5 py-20 text-center md:px-8 lg:py-24" data-id="element-87" data-mp="1np9cul1hkh86">
        <span className="mx-auto block h-px w-12 bg-copper" aria-hidden="true" data-id="element-88" data-mp="1so2tunfzeqd3" />
        <h2 className="mx-auto mt-8 max-w-[760px] font-display text-[32px] font-bold leading-[1.1] lg:text-[44px]" data-id="element-89" data-mp="1slzuhcsxvkvp">
          Approach your next diesel fault with a clearer process.
        </h2>
        <p className="mx-auto mt-5 max-w-[580px] text-[17px] leading-[1.7] text-mist lg:text-[18px]" data-id="element-90" data-mp="1ir7tdz05efw6">
          Bring visual references, diagnostic guidance, and practical workshop resources together with Diesel Fault Atlas.
        </p>
        <p className="mt-8 font-mono text-[13px] uppercase tracking-[0.12em] text-copper" data-id="element-91" data-mp="2z4ele5oat9zp">6 volumes + 5 included bonuses</p>
        <div className="mt-4 flex justify-center" data-id="element-92" data-mp="3426lvo30e4fi">
          <PriceTag size="md" tone="dark" data-id="element-93" data-mp="340vhbm1qosnc" />
        </div>
        <div className="mt-7 flex justify-center" data-id="element-94" data-mp="27ts9zc50vxw">
          <PurchaseButton mode="auto" className="w-full sm:w-auto" data-id="element-95" data-mp="3tffppa89k26b" />
        </div>
        <p className="mt-4 text-[14px] text-mist" data-id="element-96" data-mp="3tdbm6tea156k">Digital reference collection. No physical books or diagnostic equipment are shipped.</p>
      </div>
    </section>;
}